// extracted by mini-css-extract-plugin
export default {"dot":"ComplexityDot_dot__yHHp+","easy":"ComplexityDot_easy__o3SOB","medium":"ComplexityDot_medium__ZZM7n","hard":"ComplexityDot_hard__G35wr"};